import { render, staticRenderFns } from "./reset-multi-case.vue?vue&type=template&id=23244d58"
import script from "./reset-multi-case.vue?vue&type=script&lang=js"
export * from "./reset-multi-case.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports